import { useState, useEffect } from 'react';
import type { ChartType } from './ChartTypeSelector';

export const useChartType = (key: string, defaultType: ChartType = 'area') => {
  // Get initial value from localStorage or use default
  const [chartType, setChartType] = useState<ChartType>(() => {
    const saved = localStorage.getItem(`chart-type-${key}`);
    return (saved as ChartType) || defaultType;
  });

  // Update localStorage when chartType changes
  useEffect(() => {
    localStorage.setItem(`chart-type-${key}`, chartType);
  }, [chartType, key]);

  return [chartType, setChartType] as const;
};
